import { useCallback } from 'react';
import { ExareStatus } from '@websky/graphql';
import { useConfig } from '../../../../context';

export type RefundSuccessModalStep = 'create' | 'request';

export const useShouldShowRefundSuccessModal = () => {
	const successModal = useConfig().Engine.refund?.successModal;

	return useCallback(
		(step: RefundSuccessModalStep, status: ExareStatus): boolean => successModal?.[step]?.[status] ?? true,
		[successModal]
	);
};
